import { RIGHTSHOLDER_SUB_ROUTES } from '@App/navigation/route'
import React from 'react'
import Navigation from '@App/navigation'
import RequireFeatureFlag from '@Components/Utility/RequireFeatureFlag'
import WorkMergeLayout from '@Scenes/RightsholderScene/WorkMerge/WorkMergeLayout'
import WorkMerge from '@Scenes/RightsholderScene/WorkMerge'
import WorkMergeNewRequest from '@Scenes/RightsholderScene/WorkMerge/WorkMergeNewRequest'
import WorkMergeReviewRequest from '@Scenes/RightsholderScene/WorkMerge/WorkMergeReviewRequest'
import WorkMergeRequestDetail from '@Scenes/RightsholderScene/WorkMerge/WorkMergeRequestDetail'

export const createWorkMergeRoutes = () => ({
    path: '',
    element: (
        <RequireFeatureFlag flagKey="work-merge-tool" reRouteLocation={Navigation.home.root()}>
            <WorkMergeLayout />
        </RequireFeatureFlag>
    ),
    children: [
        {
            path: RIGHTSHOLDER_SUB_ROUTES.workMerge.root,
            element: <WorkMerge />,
        },
        {
            path: RIGHTSHOLDER_SUB_ROUTES.workMerge.newRequest,
            element: <WorkMergeNewRequest />,
        },
        {
            path: RIGHTSHOLDER_SUB_ROUTES.workMerge.reviewRequest,
            element: <WorkMergeReviewRequest />,
        },
        {
            path: RIGHTSHOLDER_SUB_ROUTES.workMerge.request,
            element: <WorkMergeRequestDetail />,
        },
    ],
})
